// extracted by mini-css-extract-plugin
export default {"questionVoteBox":"e1-z","upvote":"f1-z","downvote":"g1-z","numVotes":"h1-z","votesDescription":"i1-z","report":"j1-z","voted":"k1-z","answerVoteBox":"l1-z","justReported":"m1-z"};